import React from 'react';

import { ArrowDownward } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import Card from '../Card';
import CardRecebimento from '../CardRecebimento';
import SemDados from '../SemDados';
import * as S from './styles';

function CardPioresRecebimentos({ cards, style, disabled }) {
  return (
    <Card
      title={t('s.geral.perdadescarga')}
      icon={<ArrowDownward />}
      style={style}
      tooltip={t('s.dashboard.visaogeral.tooltip.recebimentos')}
      disabled={disabled}
    >
      {cards && cards.length > 0 ? (
        <S.Container>
          {cards.map((params, index) => (
            <CardRecebimento key={index} params={params} />
          ))}
        </S.Container>
      ) : (
        <SemDados />
      )}
    </Card>
  );
}

CardPioresRecebimentos.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  style: PropTypes.objectOf(PropTypes.any),
  disabled: PropTypes.bool,
};

CardPioresRecebimentos.defaultProps = {
  style: {},
  disabled: false,
};

export default CardPioresRecebimentos;
